import DescriptionIcon from '@mui/icons-material/Description'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton
} from '@mui/material'
import { FC } from 'react'

import {
  EntryWithRelated,
  PromptWithRelated
} from '../../../models/inspections'
import { PromptNotesField } from './PromptNotesField'

interface Props {
  prompt: PromptWithRelated
  entry: EntryWithRelated
  setEntry: (entry: EntryWithRelated) => void
  open: boolean
  setOpen: (open: boolean) => void
}

const PromptNotesDialog: FC<Props> = ({
  prompt,
  entry,
  setEntry,
  open,
  setOpen
}) => {
  const updateCallback = (updatedPrompt: PromptWithRelated) => {
    setEntry({ ...entry, prompts: [updatedPrompt] })
  }
  return (
    <>
      <IconButton
        onClick={(event) => {
          event?.stopPropagation()
          setOpen(true)
        }}
        color={prompt.info!.technicianNotes ? 'primary' : 'default'}>
        <DescriptionIcon />
      </IconButton>
      <Dialog open={open} fullWidth maxWidth="sm">
        <DialogTitle>Notes</DialogTitle>
        <DialogContent>
          <PromptNotesField {...{ prompt, updateCallback }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default PromptNotesDialog
